export default __webpack_public_path__ + "static/media/mini-gold-card@3x.0d7c758b.png";